import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import theme from "../../../styles/theme";
const sizing = {
  xSmall: `
    font-size: ${theme.sizes.xs}; //12px
  `,
  small: `
    font-size: ${theme.sizes.s}; //14px
  `,
  mediumSmall: `
    font-size: ${theme.sizes.m}; //16px
  `,
  medium: `
    font-size: ${theme.sizes.l}; //18px
  `,
  large: `
    font-size: ${theme.sizes.xl2}; //22px
  `,
  xLarge: `
    font-size: ${theme.sizes.xl3m}; //28px
  `,
  xxLarge: `
    font-size: ${theme.sizes.xl4}; //32px
  `,
  xxxLarge: `
    font-size: ${theme.sizes.xl6}; //48px
  `
};

const Text = styled.p.attrs(({ text, children, isThemeReverse, isSerif }) => ({
  children: text || children,
  isThemeReverse,
  isSerif
}))`
  /*
  -- Size
  */
  ${props =>
    props.fontSize
      ? `font-size: ${props.fontSize}`
      : sizing[props.size || "small"]};
  /*
  -- Other props
  */
  font-family: ${props =>
    props.fontFamily ||
    (props.isSerif ? props.theme.type.serif : props.theme.type.base)};
  color: ${props =>
    props.color ||
    (props.isThemeReverse
      ? props.theme.components.text.colorReverse
      : props.theme.components.text.color)};
  line-height: ${props => props.lineHeight || "1.5"};
  font-weight: ${props => props.fontWeight || props.theme.weight.light};

  transform: ${props => props.transform};
  text-transform: ${props => props.textTransform};

  display: ${props => props.display};
  visibility: ${props => props.visibility};
  /*
  -- Margin
  */
  margin-top: ${props => props.marginTop};
  margin-right: ${props => props.marginRight};
  margin-bottom: ${props => props.marginBottom};
  margin-left: ${props => props.marginLeft};
  /*
  -- Padding
  */
  padding-top: ${props => props.paddingTop};
  padding-bottom: ${props => props.paddingBottom};

  word-break: break-word;

  :first-letter {
    text-transform: ${props => props.firstLetter};
  }

  /*
  -- Responsive
  */
  // Small devices (landscape phones, less than 768px)
  @media (max-width: 767px) {
    font-size: ${props => props.mobileSmFontSize};
  }

  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575px) {
    font-size: ${props => props.mobileXsFontSize};
  }
`;

Text.defaultProps = {
  isThemeReverse: false,
  isSerif: false
};

Text.propTypes = {
  fontSize: PropTypes.string,
  fontFamily: PropTypes.string,
  isSerif: PropTypes.bool,
  color: PropTypes.string,
  isThemeReverse: PropTypes.bool,
  lineHeight: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  display: PropTypes.string,
  visibility: PropTypes.string,
  textTransform: PropTypes.string,
  transform: PropTypes.string,
  marginTop: PropTypes.string,
  marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginBottom: PropTypes.string,
  marginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  firstLetter: PropTypes.string,
  mobileSmFontSize: PropTypes.string,
  mobileXsFontSize: PropTypes.string
};

export default Text;
